var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-h-6",attrs:{"icon":"session-ai","variant":"info","title":_vm.$options.i18n.tooltip,"aria-label":_vm.$options.i18n.label,"data-testid":"commit-agent-session-badge"}})
}
var staticRenderFns = []

export { render, staticRenderFns }